import React from 'react';
import ReactDOM from 'react-dom';
import './css/global.css';
//import App from './pages/Login';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));


